import React, { Component, ReactNode } from 'react';
import { Container, Button, Card } from './index';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: undefined });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <Container maxWidth="md">
          <div style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
            <Card padding="lg" shadow="md">
              <div style={{ textAlign: 'center' }}>
                <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: 'var(--color-error)' }}>
                  Something went wrong
                </h1>
                <p style={{ marginBottom: '2rem', color: 'var(--color-text-secondary)' }}>
                  {this.state.error?.message || 'An unexpected error occurred'}
                </p>
                <Button onClick={this.handleReset}>Go to Home</Button>
              </div>
            </Card>
          </div>
        </Container>
      );
    }

    return this.props.children;
  }
}
